import { aiSkillsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_SKILLS_ACTION_TYPE = createNamedActions('aiSkills', {
  GET_AI_SKILLS: 'GET_AI_SKILLS',
  GET_AI_SKILL_TEMPLATES: 'GET_AI_SKILL_TEMPLATES',
  CREATE_AI_SKILL: 'CREATE_AI_SKILL',
  UPDATE_AI_SKILL: 'UPDATE_AI_SKILL',
  DELETE_AI_SKILL: 'DELETE_AI_SKILL',
  CLONE_AI_SKILL: 'CLONE_AI_SKILL',
  ENABLE_AI_SKILL: 'ENABLE_AI_SKILL',
  DISABLE_AI_SKILL: 'DISABLE_AI_SKILL',
  RESET_AI_SKILLS_STATE: 'RESET_AI_SKILLS_STATE',
});

export const getAiSkillsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await aiSkillsApi.getAiSkills();

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.GET_AI_SKILLS,
    payload: data,
  });
});

export const getAiSkillTemplatesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await aiSkillsApi.getAiSkillTemplates();

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.GET_AI_SKILL_TEMPLATES,
    payload: data,
  });
});

export const createAiSkillAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiSkillsApi.createAiSkill(params);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.CREATE_AI_SKILL,
    payload: data,
  });
});

export const updateAiSkillAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiSkillsApi.updateAiSkill(params);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.UPDATE_AI_SKILL,
    payload: data,
  });
});

export const deleteAiSkillAction = catchAsyncActionError(id => async dispatch => {
  await aiSkillsApi.deleteAiSkill(id);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.DELETE_AI_SKILL,
    payload: id,
  });
});

export const cloneAiSkillAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiSkillsApi.cloneAiSkill(id);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.CLONE_AI_SKILL,
    payload: data,
  });
});

export const enableAiSkillAction = catchAsyncActionError(id => async dispatch => {
  await aiSkillsApi.enableAiSkill(id);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.ENABLE_AI_SKILL,
    payload: id,
  });
});

export const disableAiSkillAction = catchAsyncActionError(id => async dispatch => {
  await aiSkillsApi.disableAiSkill(id);

  return dispatch({
    type: AI_SKILLS_ACTION_TYPE.DISABLE_AI_SKILL,
    payload: id,
  });
});

export const resetAiSkillsStateAction = () => ({
  type: AI_SKILLS_ACTION_TYPE.RESET_AI_SKILLS_STATE,
});
